<template>
  <v-layout column class="ma-0 pa-0">
    <vue-snotify></vue-snotify>
    <v-row justify="end" dense>
      <v-col cols="12" xs="12" sm="3" md="3">
        <v-text-field
          hide-details
          solo
          clearable
          v-model="search"
          append-icon="icons8-search-4"
          label="Search"
          @click:clear="clearSearch"
        ></v-text-field>
      </v-col>
      <v-col cols="12" xs="12" sm="6" md="3">
        <!-- // ! RG - Modified :items="tags" to :items="filterTags" -->
        <v-select
          hide-details
          solo
          clearable
          multiple
          v-model="filterApplied"
          append-icon="icons8-filter-3"
          :items="filterTags"
          label="Filter topics"
        ></v-select>
      </v-col>
    </v-row>
    <!-- Item list testing needs update-->

    <div v-if="topicsList.length === 0" class="text-center mt-12 py-12">
      <v-progress-circular
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>
    <v-item-group v-else>
      <v-container fluid class="ma-0 pa-0">
        <v-row align="stretch" justify="start">
          <v-col
            class="d-flex mt-10 mb-10"
            v-for="(item, index) in filteredItems"
            :key="index"
            style="height: 400px !important;"
            cols="12"
            md="6"
            sm="6"
            lg="4"
            xl="4"
          >
            <v-card
              class="d-flex flex-column card-outter grey lighten-4 ma-0 pa-0"
              style="width: 100%; height: 120%;"
            >
              <v-img
                v-if="item.photoURL === ''"
                :aspect-ratio="16 / 9"
                height="150"
                src="https://cdn.vuetifyjs.com/images/parallax/material.jpg"
              ></v-img>
              <v-img
                v-else
                :aspect-ratio="16 / 9"
                height="150"
                :src="item.photoURL"
              ></v-img>
              <v-progress-linear
                color="secondary"
                value="100"
                height="8"
              ></v-progress-linear>
              <v-card-title
                class="text-h6 font-weight-light text-uppercase justify-space-between primary--text"
                style="letter-spacing: -1px !important;"
              >
                <span v-if="userLevel === '100'" @click="openTopic(item.id)">{{ item.name }}</span>
                <span v-else>{{ item.name }}</span>

                <!-- <v-spacer /> -->
                <!-- <v-chip
                  v-for="(it, index) in item.tags"
                  :key="index"
                  class="hidden-md-and-down mr-1  mb-2 secondary font-weight-normal black--text"
                  style="letter-spacing: 0.5px !important;"
                  small
                >
                  {{ it }}
                </v-chip> -->
              </v-card-title>
              <v-card-text class="mt-0 truncate">
              <v-chip
                  v-for="(it, index) in item.tags"
                  :key="index"
                  class="hidden-md-and-down mr-1  mb-2 secondary font-weight-normal black--text"
                  style="letter-spacing: 0.5px !important;"
                  small
                >
                  {{ it }}
                </v-chip>   
               </v-card-text>
               <!-- <v-spacer></v-spacer> -->
              <v-card-text class="truncate">
                {{ item.description }}
              </v-card-text>
              <v-spacer></v-spacer>
              <!-- two buttons-->
              <v-card-actions class="px-4 mb-0">
                <v-row v-if="courseStatus(item.id) === 'unlock'">
                  <!-- Added by Ryan to Filter  -->
                  <!-- // ! Added || item.availableFrom === '' -->
                  <v-col
                    v-if="
                      $moment(item.availableFrom, 'YYYY-MM-DD') <= $moment() ||
                        item.availableFrom === undefined || item.availableFrom === '' || item.availableFrom === null
                    "
                  >
                    <v-btn block class="accent" @click="unlockContent(item)"
                      >Unlock</v-btn
                    >
                  </v-col>
                  <v-col v-else class="d-flex align-center" align="center">
                    <span class="primary--text body-2 font-weight-bold"
                      >Available
                      {{
                        $moment(item.availableFrom, "YYYY-MM-DD").format(
                          "DD-MMM"
                        )
                      }}
                    </span>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn
                      block
                      v-if="item.buyNowURL != ''"
                      :href="item.buyNowURL"
                      target="_blank"
                      class="primary"
                      >Buy Now</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row v-if="courseStatus(item.id) === 'activate'">
                  <v-col class="text-right">
                    <v-btn block class="primary" @click="activateTopic(item.id)"
                      >Activate</v-btn
                    >
                  </v-col>
                </v-row>
                <v-row v-if="courseStatus(item.id) === 'viewcontent'">
                  <v-col class="d-flex align-center" align="center">
                    <span
                      v-if="courseStatus(item.id) === 'viewcontent'"
                      class="error--text body-2 font-weight-bold"
                      >Expires: {{ returnCountdownDate(item.id) }}<br
                    /></span>
                  </v-col>
                  <v-col class="text-right">
                    <v-btn block class="primary" @click="openTopic(item.id)"
                      >View</v-btn
                    >
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-item-group>
    <v-row justify="center" align="center">
      <v-dialog
        v-model="unlockDialog"
        persistent
        :fullscreen="$vuetify.breakpoint.mobile"
        width="60%"
        ><!-- Added mobile breakpoint for full screen -->
        <v-card class="px-6 py-6"> 
          <UnlockContent
            v-on:close-dialog="closeUnlockDialog"
            :content="topicContent"
          />
        </v-card>
      </v-dialog>
    </v-row>
  </v-layout>
</template>

<script>
import UnlockContent from "./UnlockContentPopUp.vue";
import { Snotify, SnotifyPosition, SnotifyToast } from "vue-snotify";
import countdown from "moment-countdown";
import { mapState } from 'vuex';

export default {
  name: "TopicsNormalUser",
  components: {
    UnlockContent,
  },
  data: () => ({
    topicsList: [],
    unlockDialog: false,
    topicContent: [],
    coursesList: [],
    search: "",
    filterApplied: [],
    tags: ["Biology", "Physics", "Chemestry"], // TODO RG - Remove if not necessary
    tagsList: [], // ! RG - Added for Database Tag List
    codesForm: {},
    userLevel: null // ! RG - Required for Adding Preview
  }),
  computed: {
    ...mapState({
      myuser: state => state.currUser
    }),
    filteredItems() {
      return this.$orderBy(
        this.topicsList.filter((item) => {
          if (!this.search && this.filterApplied.length === 0)
            return this.topicsList;
          else if (this.search && this.filterApplied.length === 0) {
            return (
              item.name.toLowerCase().includes(this.search.toLowerCase()) ||
              item.description.toLowerCase().includes(this.search.toLowerCase())
            );
          } else if (!this.search && this.filterApplied) {
            return item.tags.some((r) => this.filterApplied.includes(r));
          } else if (this.search && this.filterApplied) {
            return (
              item.name.toLowerCase().includes(this.search.toLowerCase()) ||
              item.description
                .toLowerCase()
                .includes(
                  this.search.toLowerCase() &&
                    item.tags.some((r) => this.filterApplied.includes(r))
                )
            );
          }
        }),
        "name"
      );
    },
    // ! RG - Added to filterTags
    filterTags() {
      var objTags = [];
      for (var i = 0; i < this.tagsList.length; i++) {
        objTags.push(this.tagsList[i].name);
      }
      return objTags;
    },
  },
  watch: {},
  methods: {

    // ! RG - Added readTagsFromDB as tag list had not been updated 
    readTagsFromDB() {
      var self = this;
      this.$firebase.db.collection("tags").onSnapshot((querySnapshot) => {
        self.tagsList = [];
        var Data = [];
        querySnapshot.forEach((doc) => {
          Data = doc.data();
          Data.id = doc.id;
          self.tagsList.push(Data);
        });
      });
    },


    readTopics() {
      var self = this;
      this.$firebase.db
        .collection("topics")
        .where("status", "==", "Published")
        .onSnapshot((querySnapshot) => {
          self.topicsList = [];
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            self.topicsList.push(Data);
          });
        });
    },
    readCourses() {
      var self = this;
      //console.log('myuser = ' + this.myuser)
      var currentUserID = this.myuser.id;
     // console.log('currentUserID === ' + currentUserID)
      this.$firebase.db
        .collection("courses")
        .where("userID", "==", currentUserID)
        .where("authorised", "==", true) // ! RG - added this to filter on authorised
        .onSnapshot((querySnapshot) => {
          self.coursesList = [];
          var Data = [];
          querySnapshot.forEach((doc) => {
            Data = doc.data();
            Data.id = doc.id;
            // ! - RG - Needed to filter out old courses
           // console.log(Data.id + ' | ' + this.$moment(Data.expiryDate, 'YYYY-MM-DD').endOf('day').format('YYYY-MM-DD HH:mm:ss') + '    >    ' + this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss'))
            if (this.$moment(Data.expiryDate, "YYYY-MM-DD").endOf('day').format('X') >= this.$moment().endOf('day').format('X')) {
              self.coursesList.push(Data);
            }
          });
        });
    },
    openTopic(id) {
      this.$router.push("/topics/topic/" + id).catch((err) => {});
    },
    unlockContent(item) {
      this.topicContent = item;
     // console.log(JSON.stringify(this.topicContent, null, 2));
      this.unlockDialog = true;
    },
    closeUnlockDialog() {
      this.unlockDialog = false;
    },
    clearSearch() {
      this.search = "";
    },

    // function to determine whether a topic has been unlocked
    courseStatus(id) {
      var value;
      //console.log('this.coursesList = ' + this.coursesList.length)
      if (this.coursesList.length !== 0) {
        var today = this.$moment().endOf('Day').format('X')
        var course = this.$find(this.coursesList, function(o) {
          return o.topicId === id;
        });
       // console.log(JSON.stringify(course, null, 2));
        if (course !== null && course != undefined) {
          // ! RG - SWAPPED IF STatements around
          if (course.authorised === true && (course.expiryDate === null || course.expiryDate === '')) {
            return "activate";
          } else if (course.authorised === true && (this.$moment(course.expiryDate).endOf('day').format('X') >= this.$moment().endOf('day').format('X'))) {
            return "viewcontent"; 
          } else return "unlock";
        } else {
          return "unlock";
        }
      } else {
        return "unlock";
      }

      // return value;
    },
    activateTopic(id) {
      if (this.coursesList != 0) {
        var course = this.$find(this.coursesList, function(o) {
          return o.topicId === id;
        });

        this.$snotify.confirm(
          "Once the topic is activated it will only be available for 21 days.",
          "Are you sure you want to activate this topic?",
          {
            titleMaxLength: 250,
            maxOnScreen: 1,
            closeOnClick: false,
            pauseOnHover: true,
            position: SnotifyPosition.centerCenter,
            buttons: [
              //Yes
              {
                text: "Yes",
                action: (toast) => this.yesAction(course.id, toast),
                bold: false,
              },
              //No
              { text: "No", action: (toast) => this.$snotify.remove(toast.id) },
            ],
          }
        );
      }
    },
    yesAction(courseId, toast) {
      //set the expiry date to 21 days after the current date
      var date = this.$moment(); //new Date();
      var newDate = this.$moment(date.add(21, "d")).toISOString();
      // console.log(newDate);
      // update expiry date field in db
      var self = this;
      this.$firebase.db
        .collection("courses")
        .get()
        .then(function(querySnapshot) {
          querySnapshot.forEach(function(doc) {
            self.$firebase.db
              .collection("courses")
              .doc(courseId)
              .update({
                expiryDate: newDate,
              });
          });
        })
        .catch((error) => {
        //  console.log(error);
        });
      this.$snotify.remove(toast.id);
    },
    returnCountdownDate(id) {
      if (this.coursesList != 0) {
        var course = this.$find(this.coursesList, function(o) {
          return o.topicId === id;
        });

        var countdownTime = this.$moment(course.expiryDate).format("DD MMM YY");
        return countdownTime;
      }
    },
  },
  async created() {
    var self = this;
    this.userLevel = this.$store.getters.currUser.userTypeId
   // console.log('userssss ' + JSON.stringify(this.$store.getters.currUser))
    setTimeout(function() {
      self.readTagsFromDB(); // ! RG - Added to read Tags from DB
      self.readCourses();
      self.readTopics();
    }, 1000);
  },
  mounted() {},
};
</script>

<style>
.bla {
  letter-spacing: 10.0625em !important;
}
.card-outter {
  position: relative;
  padding-bottom: 50px !important;
}
.card-actions {
  width: 100%;
  position: absolute;
  bottom: 0;
}
.truncate {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
